import { useEffect, useState } from "react";
import { ArrowDown, Repeat } from "lucide-react";
import { api } from "@/lib/api";
import { formatEuros } from "@/lib/format";

const Couloir = ({ c }) => (
  <section className="at-card p-4 md:p-5" data-testid={`lane-${c.type}`}>
    <p className="at-label mb-3">{c.label}</p>
    {c.processus.length === 0 && <p className="text-sm at-muted">Aucun processus dans ce couloir.</p>}
    {c.processus.map((s) => (
      <div key={s.processus.id} className="mb-3 last:mb-0" data-testid={`lane-process-${s.processus.id}`}>
        <p className="font-bold text-sm mb-2">{s.processus.nom} <span className="at-muted font-semibold">· {s.total} fiche(s) · {formatEuros(s.montant_total)}</span></p>
        <div className="flex gap-2 overflow-x-auto no-scrollbar snap-x pb-1">
          {s.etapes.map((e) => (
            <div key={e.code} className="at-soft px-3 py-2 shrink-0 snap-start min-w-[120px]" data-testid={`lane-step-${s.processus.id}-${e.code}`}>
              <span className="block h-1 at-pill mb-1.5" style={{ background: e.temperature || "var(--muted)" }} />
              <p className="text-xs font-semibold truncate max-w-[140px]">{e.nom}</p>
              <p className="font-bold">{e.nombre}</p>
            </div>
          ))}
        </div>
      </div>
    ))}
  </section>
);

export const Couloirs = () => {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/vues/couloirs").then((r) => setData(r.data)); }, []);
  if (!data) return null;
  return (
    <div className="space-y-2" data-testid="view-couloirs">
      {data.couloirs.map((c, i) => {
        const relais = data.relais.filter((r) => r.de_type === c.type);
        return (
          <div key={c.type}>
            <Couloir c={c} />
            {i < data.couloirs.length - 1 && (
              <div className="flex flex-col items-center py-2 gap-1">
                <ArrowDown size={18} className="at-muted" />
                {relais.map((r) => (
                  <p key={r.de} className="text-xs at-soft px-3 py-2 max-w-full break-words flex gap-2" data-testid="lane-relay">
                    <Repeat size={14} className="shrink-0 mt-0.5" /><span><b>Relais</b> {r.de} → {r.vers}. Repris par : {r.repris_par}.</span>
                  </p>
                ))}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};
